module.exports = __webpack_public_path__ + "51b1d3c4126660fc44db9f8afec06fd3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/Images/SwiftImageIcons/Colored/1x/Shakinghands.png
// module id = 534
// module chunks = 0